import { useEffect, useState } from 'react';
import { useSetImmerAtom } from 'jotai-immer';
import { tableFiltersVM, tableStatsVM, tableViewVM } from '../../../../core/table/table_view_models';
import {
    SPLIT_ORDER_INVOICES_LIST_STORAGE_KEY,
    SPLIT_ORDER_INVOICES_LIST_VIEW_KEY,
} from '../../split_order_invoices_const';
import {
    tableStateAtom,
    tableViewAtom,
    splitOrderInvoicesDataAtom,
    tableStatsAtom,
    tableFiltersAtom,
    setAtomSplitOrderInvoicesListTableViewState,
} from '../split_order_invoices_list_atoms';
import {
    splitOrderInvoicesListAllColumnsView,
    splitOrderInvoicesListColumnSpec,
} from './SplitOrderInvoicesListTableSpec';
import viewStateRepo from '../../../../core/repo/viewStateRepo';
import { tableDataVM, tableStateVM } from '../../../../core/table/table_view_models';
import { SplitOrderInvoicesDataItem } from '../split_order_invoices_list_types';
import { ListTableInitHookReturn } from '../../../../core/table/table.types';
import { tblSpecLoadStorage, tblSpecLoadView } from '../../../../core/table/tableViewsRepo';

export const useSplitOrderInvoicesListTableInit = (): ListTableInitHookReturn => {
    const [init, setInit] = useState(true);
    const setState = useSetImmerAtom(tableStateAtom);
    const setView = useSetImmerAtom(tableViewAtom);
    const setList = useSetImmerAtom(splitOrderInvoicesDataAtom);
    const setStats = useSetImmerAtom(tableStatsAtom);
    const setFilter = useSetImmerAtom(tableFiltersAtom);

    useEffect(() => {
        setState(draft => {
            if (init && !draft.waiting) {
                setInit(false);
                const colSpec = splitOrderInvoicesListColumnSpec();
                const defaultView = splitOrderInvoicesListAllColumnsView();
                const savedViews = tblSpecLoadStorage(SPLIT_ORDER_INVOICES_LIST_VIEW_KEY, colSpec, defaultView);
                draft.views = savedViews.views;
                draft.currentViewId = defaultView.key;
                setView(() => tblSpecLoadView(savedViews.current, savedViews.views, colSpec) || tableViewVM());
                const viewstate = viewStateRepo.getTable(
                    SPLIT_ORDER_INVOICES_LIST_STORAGE_KEY,
                    Array.from(colSpec.keys()),
                );
                if (!!viewstate) {
                    setView(draft => {
                        draft.sort = viewstate.sort;
                    });
                    setFilter(() => viewstate.flt);
                    setStats(draft => {
                        draft.paging = viewstate.paging;
                    });
                }
                return draft;
            }
        });
        /* eslint-disable-next-line */
    }, []);

    useEffect(() => {
        return (): void => {
            setAtomSplitOrderInvoicesListTableViewState();
            setState(() => tableStateVM());
            setView(() => tableViewVM());
            setFilter(() => tableFiltersVM());
            setStats(() => tableStatsVM());
            setList(() => tableDataVM<SplitOrderInvoicesDataItem>());
        };
    }, [setFilter, setList, setState, setStats, setView]);

    return { init };
};
